import { Component, Input, Output, EventEmitter } from '@angular/core';

import { HisAuthService, HisNotificationService, HisUiService, HisGenericValueService } from 'hisng';

import { Habilitation } from '../../../../../doctoral/model/habilitation';
import { HabilitationService } from 'app/fs/res/doctoral/service/habilitation.service';

@Component( {
    selector: 'res-doctorate-panel',
    templateUrl: './doctorate-panel.component.html',
} )

export class DoctoratePanelComponent {
    @Output() selectedDoctoratesChange = new EventEmitter<Habilitation[]>();
    @Input() selectedDoctorates: Habilitation[] = [];
    @Input() dDKey = 'fs.res.common.doctorates';

    private isAddDoctorate: boolean;
    selectedDoctorate: Habilitation;
    filteredDoctorate: any[];

    constructor(
        public auth: HisAuthService,
        private notificationService: HisNotificationService,
        private genericValueService: HisGenericValueService,
        private hisUiService: HisUiService,
        private habilitationService: HabilitationService
    ) { }

    // getter #######################################################################################################################
    getIsAddDoctorate(): boolean {
        return this.isAddDoctorate;
    }

    getSelectedDoctorates(): Habilitation[] {
        return this.selectedDoctorates;
    }

    // autocomplete functions #########################################################################################################
    filterDoctorate( event: { query: string } ) {
        let query = event.query;
        this.habilitationService.getValues( query ).subscribe( ( filteredOptions: Habilitation[] ) => {
            this.filteredDoctorate = null; // filteredOptions;
        } );
    }

    // Button actions ---------------------------------------------------------
    setIsAddDoctorate() {
        this.isAddDoctorate = true;
    }

    addDoctorate() {
        if ( !this.selectedDoctorate ) {
            this.notificationService.errorI18nRes( 'fs.res.common.error.doctorate' );
        } else {
            let containedDoctorate =
                this.genericValueService.findRowByValue( this.selectedDoctorates, this.selectedDoctorate.id );
            if ( !containedDoctorate ) {
                this.selectedDoctorates = [...this.selectedDoctorates, this.selectedDoctorate];
                this.selectedDoctoratesChange.emit( this.selectedDoctorates );
            } else {
                this.notificationService.warnI18n( 'fs.res.common.warning.doctorate', containedDoctorate.label );
            }
        }
        this.isAddDoctorate = false;
        this.selectedDoctorate = null;
    }

    deleteDoctorate( index: number ) {
        this.selectedDoctorates = this.genericValueService.deleteRow( this.selectedDoctorates, index );
        this.selectedDoctoratesChange.emit( this.selectedDoctorates );
    }
}
